import { ReflectorBody } from '@/infrastructure/reflector/ReflectorBody';
import { ReflectorBodyIntegration } from '@/infrastructure/reflector/ReflectorBodyIntegration';
import { IBodyInfo } from './IBodyInfo';
import { arrayFirstItemOrNull } from '@/platform/core/ArrayExtensions';
import { ResponseError } from 'superagent';
import { ReflectorRequestError } from '@/infrastructure/reflector/ReflectorRequestError';
import { PlatformIntegration } from '@/platform/PlatformIntegration';

class BodyService extends ReflectorBodyIntegration {
	public async create(info: IBodyInfo): Promise<string> {
		try {
			const authorizationPut =
				await PlatformIntegration.instance.authorizer.authorizeBodyCreate();
			const result = await this.sendPut<ReflectorBody>(
				'/data/bodies/any/details/',
				this.toUrlEncodedForPut(info),
				authorizationPut,
			);

			const createdBody = arrayFirstItemOrNull(this.reconstituteAll(result));
			if (createdBody === null) {
				throw new ReflectorRequestError();
			}

			const idOfBody = createdBody.id;

			const authorizationPost =
				await PlatformIntegration.instance.authorizer.authorizeBodyUpdate(
					idOfBody,
				);
			await this.sendPost(
				`/data/bodies/any/details/${idOfBody}/`,
				this.toUrlEncodedForPost(info),
				authorizationPost,
			);

			return idOfBody;
		} catch (error) {
			this.tryThrowAbstractedError(error as ResponseError);
			throw error;
		}
	}

	public toUrlEncodedForPut(info: IBodyInfo): string {
		return `name=${encodeURIComponent(info.name)}`;
	}

	public toUrlEncodedForPost(info: IBodyInfo): string {
		return `params[name]=${encodeURIComponent(info.name)}&params[type]=${encodeURIComponent(info.type)}`;
	}
}

export default new BodyService();
